import type {
  SendInternalConsultRequestByIntranetIdRequest,
  SendInternalConsultRequestResponse
} from '@/models/interface/consult';
import { ApiFactory, type ApiDataResponse } from '@/utils/api';

export class ConsultService extends ApiFactory {
  constructor() {
    super('Consult');
  }

  /**
   * 呼叫內部 API 同步諮詢請求 (前端直接帶 IntranetId，不需 ChannelId)
   * @param data 學員 MemberId、IntranetId、來源、對話紀錄
   * @returns 同步結果
   */
  sendInternalConsultRequestByIntranetId(
    data: SendInternalConsultRequestByIntranetIdRequest
  ): Promise<ApiDataResponse<SendInternalConsultRequestResponse>> {
    return super.post('SendInternalConsultRequestByIntranetId', data, {
      baseURL: import.meta.env.VITE_LIVESTREAM_BASE_URL,
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }
}
